import { useReducer, useState } from "react";

interface TableSelectionState {
  selectedIds: string[];
}

type TableSelectionAction =
  | {
      type: "ADD_IDS_TO_SELECTION";
      payload: string[];
    }
  | {
      type: "REMOVE_IDS_FROM_SELECTION";
      payload: string[];
    }
  | {
      type: "CLEAR_SELECTION";
      payload?: undefined;
    }
  | {
      type: "SELECT_ALL";
      payload?: string[];
    };

function tableSelectionReducer(
  state: TableSelectionState,
  action: TableSelectionAction,
): TableSelectionState {
  const { type, payload } = action;
  switch (type) {
    case "ADD_IDS_TO_SELECTION": {
      const newIds = payload.filter((id) => state.selectedIds.indexOf(id) < 0);
      return { selectedIds: [...state.selectedIds, ...newIds] };
    }
    case "REMOVE_IDS_FROM_SELECTION": {
      return {
        selectedIds: state.selectedIds.filter((id) => payload.indexOf(id) < 0),
      };
    }
    case "CLEAR_SELECTION": {
      return { selectedIds: [] };
    }
    case "SELECT_ALL": {
      return { selectedIds: payload ? payload : [] };
    }
  }
}

export function useTableSelection() {
  const [state, dispatch] = useReducer(tableSelectionReducer, {
    selectedIds: [],
  });

  const addSelectedIds = (ids: string[]) =>
    dispatch({ type: "ADD_IDS_TO_SELECTION", payload: ids });
  const removeSelectedIds = (ids: string[]) =>
    dispatch({ type: "REMOVE_IDS_FROM_SELECTION", payload: ids });
  const clearSelection = () => dispatch({ type: "CLEAR_SELECTION" });
  const selectAll = (ids?: string[]) =>
    dispatch({ type: "SELECT_ALL", payload: ids });
  const [lastSelectedId, setLastSelectedId] = useState<string | undefined>(
    undefined,
  );

  return {
    selectedIds: state.selectedIds,
    addSelectedIds,
    removeSelectedIds,
    clearSelection,
    selectAll,
    lastSelectedId,
    setLastSelectedId,
  };
}
